export default {
  en: {
    required() {
      return "required";
    },
    email_exists() {
      return `This email is already in use.`;
    },
    password_too_short() {
      return "This password is to short, at least 8 chars are required.";
    },
    email_invalid({ value }) {
      return `${value} is not a valid email.`;
    },
    onetimecode_invalid() {
      return "This Onetime Code doesnt exists";
    },
  },
  de: {
    required() {
      return "Pflichtfeld";
    },
    email_exists() {
      return `Diese E-Mail wird bereits verwendet.`;
    },
    password_too_short() {
      return "Dieses Passwort ist zu kurz, mindestens 8 Zeichen.";
    },
    email_invalid({ value }) {
      return `${value} ist keine gültige E-Mail.`;
    },
    confirm() {
      return "Stimmt nicht überein.";
    },
    onetimecode_invalid() {
      return "Dieser Einmalcode existiert nicht.";
    },
  },
};
